import Vue from "vue";

const initialState = (dataObjectParams) => {
  let capitalizeFletter = dataObjectParams.stateName[0].toUpperCase() + dataObjectParams.stateName.slice(1);
  return {
    data() {
      let dataObject = {};
      //  foo-table start
      dataObject["filteredFields" + capitalizeFletter] = [];
      dataObject[dataObjectParams.filteredItemList] = [];
      dataObject.filterIncludedFields = dataObjectParams.filterIncludedFields;
      dataObject.totalRows = 1;
      dataObject.bTableWidth = 0;
      dataObject.currentPage = 1;
      dataObject.perPage = 10;
      dataObject.ratioWidthOfHistoryTableToMainTable = 0.61022120518688;
      //  foo-table end
      // history foo table start
      dataObject.filterIncludedFieldHistories = dataObjectParams.filterIncludedFieldHistories;
      dataObject.fieldsHistories = dataObjectParams.fieldsHistories;
      dataObject.totalRowsHistories = 1;
      dataObject.bTableWidthHistory = 0;
      dataObject.currentPageHistory = 2;
      dataObject.perPageHistory = 10;
      dataObject.isAResponsiveTable = dataObjectParams.isAResponsiveTable;
      dataObject.rowDetails = dataObjectParams.rowDetails;
      dataObject.baseSelectModel = "";
      //history foo table end
      return dataObject;
    },
    methods: {
      idGenerator() {
        return Math.random().toString(36).substr(2, 9);
      },
      clickFirstEntityOfList() {
        this.$nextTick(() => {
          let firstRow = document.querySelector("[aria-rowindex='1']");
          if (firstRow) {
            firstRow.click();
          }
        });
      },
      setBaseSelectDefaultValue() {
        this["baseSelectModel"] = "";
      },

      fetchColoumnsWithCurrentWidth() {
        const fields = dataObjectParams.fields;
        const fieldsHistory = dataObjectParams.fieldsHistories;
        if (dataObjectParams.isAResponsiveTable !== undefined && dataObjectParams.isAResponsiveTable) {
          this["filteredFields" + capitalizeFletter] = [...fields];
        } else if (dataObjectParams.rowDetails === undefined || dataObjectParams.rowDetails.length === 0) {
          this["filteredFields" + capitalizeFletter] = [...fields];
        } else {
          switch (true) {
            case this.bTableWidth < 576:
              this["filteredFields" + capitalizeFletter] = [...fields];
              dataObjectParams.rowDetails
                .filter((item) => item.width >= 576)
                .forEach((row) => {
                  let findIndex = this["filteredFields" + capitalizeFletter].findIndex((item) => item.key === row.name);
                  this["filteredFields" + capitalizeFletter].splice(findIndex, 1);
                });
              break;
            case this.bTableWidth < 768:
              this["filteredFields" + capitalizeFletter] = [...fields];
              dataObjectParams.rowDetails
                .filter((item) => item.width >= 768)
                .forEach((row) => {
                  let findIndex = this["filteredFields" + capitalizeFletter].findIndex((item) => item.key === row.name);
                  this["filteredFields" + capitalizeFletter].splice(findIndex, 1);
                });
              break;
            case this.bTableWidth < 1200:
              this["filteredFields" + capitalizeFletter] = [...fields];
              dataObjectParams.rowDetails
                .filter((item) => item.width >= 1200)
                .forEach((row) => {
                  let findIndex = this["filteredFields" + capitalizeFletter].findIndex((item) => item.key === row.name);
                  this["filteredFields" + capitalizeFletter].splice(findIndex, 1);
                });
              break;
            case this.bTableWidth > 1200:
              this["filteredFields" + capitalizeFletter] = [...fields];
              break;
            default:
              this["filteredFields" + capitalizeFletter] = [...fields];
          }

          switch (true) {
            case this.bTableWidthHistory < 500:
              this["fieldsHistories"] = [...fieldsHistory];
              delete this["fieldsHistories"][2];
              break;
            case this.bTableWidthHistory >= 500:
              this["fieldsHistories"] = [...fieldsHistory];
              break;
            default:
              this["fieldsHistories"] = [...fieldsHistory];
          }
        }
      },

      screenWidth() {
        Vue.set(this, "bTableWidth", window.innerWidth);
        Vue.set(this, "bTableWidthHistory", this.$refs.bTablePageWidthHistory?.offsetWidth);
      },
      filterBaseSelect(event, filterKey = "tempId", parseType = "String", isThereBaseSelectTwo = false, areBaseSelectAndBaseSelectTwoValueSame = false) {
        let itemId = event ? event : "";
        if (itemId !== "") {
          if (parseType === "Number") {
            itemId = Number(itemId);
          } else if (parseType === "String") {
            itemId = itemId + "";
          } else if (parseType === "Boolean") {
            itemId = itemId === "true";
          }
        }
        if (itemId === "") {
          if (this[dataObjectParams["filteredItemList"]].every((item) => item.intents?.[0].status === "WAITING_APPROVAL")) {
            let filtered = this[dataObjectParams.itemList].filter((item) => {
              return item.intents && item.intents[0].status === "WAITING_APPROVAL";
            });
            Vue.set(this, dataObjectParams["filteredItemList"], JSON.parse(JSON.stringify(filtered)));
          } else if (this[dataObjectParams["filteredItemList"]].every((item) => item.intents?.[0].status === "DRAFT")) {
            let filtered = this[dataObjectParams.itemList].filter((item) => {
              return item.intents && item.intents[0].status === "DRAFT";
            });
            Vue.set(this, dataObjectParams["filteredItemList"], JSON.parse(JSON.stringify(filtered)));
          } else {
            Vue.set(this, dataObjectParams["filteredItemList"], JSON.parse(JSON.stringify(this[dataObjectParams.itemList])));
          }
        } else {
          let filteredItems = this[dataObjectParams.itemList].filter((item) => item[filterKey] === itemId);
          Vue.set(this, dataObjectParams["filteredItemList"], JSON.parse(JSON.stringify(filteredItems)));
        }

        this.totalRows = this[dataObjectParams["filteredItemList"]].length;
      },

      onFiltered(filteredItems) {
        this.$nextTick(() => {
          Vue.set(this, "totalRows", filteredItems.length);
          Vue.set(this, "currentPage", 1);
        });
      },
      onFilteredHistory(filteredItemsHistory) {
        Vue.set(this, "totalRowsHistories", filteredItemsHistory.length);
        Vue.set(this, "currentPageHistory", 1);
      },
    },
    watch: {
      bTableWidth() {
        this.fetchColoumnsWithCurrentWidth();
      },
      bTableWidthHistory() {
        this.fetchColoumnsWithCurrentWidth();
      },
    },
    created() {
      window.addEventListener("resize", this.screenWidth);
    },
    mounted() {
      this.screenWidth();
      this.fetchColoumnsWithCurrentWidth();
    },
    destroyed() {
      window.removeEventListener("resize", this.screenWidth);
    },
  };
};
export default initialState;
